import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IChatLoginPayload {
    sagaCB?: any
}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const chatLogin = createSlice({
    name: 'users/chat-login',
    initialState,
    reducers: {
        onRequest(state, actions: PayloadAction<IChatLoginPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const chatLoginActions = chatLogin.actions
export default chatLogin.reducer
